import { useEffect, useState } from 'react';

export const useLocation = () => {
  const [coordinates, setCoordinates] = useState<GeolocationCoordinates>();
  useEffect(() => {
    const options = { enableHighAccuracy: true };
    const success = (pos: GeolocationPosition) => {
      setCoordinates(pos.coords);
    };
    const error = () => {
      // ok
    };
    navigator.geolocation.getCurrentPosition(success, error, options);
  }, []);
  return { coordinates };
};
